import { Link } from "react-router-dom";
import { PawPrint, Home, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import PublicNav from "@/components/PublicNav";
import { useT } from "@/lib/translations";

export default function NotFoundPage() {
  const L = useT();
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <PublicNav />

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-lg w-full text-center" data-testid="not-found-page">
          <div className="w-20 h-20 mx-auto mb-6 rounded-3xl bg-primary/10 flex items-center justify-center">
            <PawPrint className="w-10 h-10 text-primary" strokeWidth={1.5} />
          </div>
          <p className="font-heading text-6xl md:text-7xl text-primary/30 mb-3">404</p>
          <h1 className="font-heading text-3xl md:text-4xl mb-3">{L("Bu patika kayıp gitmiş")}</h1>
          <p className="text-muted-foreground leading-relaxed mb-8">
            {L("Aradığınız sayfayı bulamadık. Belki bir yazım hatası var, belki de bu can başka bir hikâyeye taşınmış. Aşağıdan geri dönebilir ya da köpekleri keşfetmeye başlayabilirsiniz.")}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" data-testid="not-found-home-btn">
              <Button className="btn-pill w-full sm:w-auto">
                <Home className="w-4 h-4 mr-2" /> {L("Ana Sayfa'ya Dön")}
              </Button>
            </Link>
            <Link to="/canlar" data-testid="not-found-dogs-btn">
              <Button variant="outline" className="btn-pill w-full sm:w-auto">
                <Search className="w-4 h-4 mr-2" /> {L("Canları Keşfet")}
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
